
export const forms = {
  'form.farmName': 'Nom de la Ferme',
  'form.yearEstablished': 'Année d\'Établissement',
  'form.carbonScore': 'Score Carbone',
  'form.irrigationMethod': 'Méthode d\'Irrigation',
  'form.certifications': 'Certifications',
  'form.staff': 'Personnel',
  'form.revenue': 'Revenus',
  'form.pastSubsidies': 'Subventions Passées',
  'form.address': 'Adresse',
  'form.registrationNumber': 'Numéro d\'Enregistrement',
  'form.certificationStatus': 'Statut de Certification',
  'form.description': 'Description',
  'form.tooltip.carbonScore': 'Score d\'impact environnemental basé sur les pratiques agricoles',
  'form.tooltip.irrigationMethod': 'Méthode utilisée pour l\'irrigation des cultures',
  'form.tooltip.certifications': 'Certifications agricoles détenues par la ferme',
  'form.tooltip.region': 'Région géographique où opère la ferme',
  'form.tooltip.size': 'Superficie totale de la ferme en hectares',
  'addFarm.manualEntry': 'Saisie Manuelle',
  'addFarm.documentUpload': 'Téléchargement de Document',
  'addFarm.frenchRegistry': 'Registre Français',
  'addFarm.chooseMethods': 'Choisissez une des méthodes ci-dessous pour ajouter une nouvelle ferme',
  'addFarm.selectIdType': 'Sélectionner le Type d\'ID',
  'addFarm.invalidFormat': 'Format {{idType}} invalide',
  'addFarm.searching': 'Recherche en cours...',
  'addFarm.resultFound': 'Ferme Trouvée',
  'addFarm.importButton': 'Importer la Ferme',
  'addFarm.noMatch': 'Aucune ferme correspondante trouvée',
  'addFarm.tryDifferentId': 'Veuillez essayer un autre ID ou utiliser la saisie manuelle',
  'addFarm.farmImported': 'Ferme importée avec succès',
  'addFarm.farmImportedDesc': 'La ferme a été ajoutée à votre portefeuille',
  'addFarm.enterFarmName': 'Entrez le nom de la ferme',
  'addFarm.enterRegion': 'Entrez la région',
  'addFarm.tagsLabel': 'Étiquettes',
  'addFarm.tagsPlaceholder': 'Ajoutez des étiquettes séparées par des virgules',
  'addFarm.dragAndDrop': 'Glissez et déposez les fichiers ici',
  'addFarm.supportedDocuments': 'Formats supportés : PDF, DOC, DOCX',
  'addFarm.selectFiles': 'Sélectionner les Fichiers',
  'addFarm.number': 'Numéro',
  'addFarm.enterValid': 'Entrez un',
  'addFarm.registryHelp': 'Utilisez l\'ID de test : 88234567890123 (SIRET) ou 123456789 (SIREN/PACAGE)',
  'addFarm.searchFarm': 'Rechercher une Ferme',
  'addFarm.registryId': 'ID de Registre',
  'addFarm.startFarmCreation': 'Commencer la Création de Ferme',
  'forms.generateForm': 'Générer le Formulaire',
  'forms.applyNow': 'Postuler Maintenant',
  'forms.estimatedTime': 'Temps Estimé',
  'forms.sections': 'Sections',
  'forms.requiredDocuments': 'Documents Requis',
  'forms.formProgress': 'Progression du Formulaire',
  'forms.autoFilled': 'Rempli Automatiquement',
  'forms.saveDraft': 'Sauvegarder le Brouillon',
  'forms.submitApplication': 'Soumettre la Candidature',
  'forms.previous': 'Précédent',
  'forms.next': 'Suivant',
  'forms.originalForm': 'Formulaire Original',
  'forms.processedView': 'Vue Traitée',
  'forms.needHelp': 'Besoin d\'Aide?',
  'forms.getHelp': 'Obtenir de l\'Aide',
  'forms.required': 'Requis',
  'forms.saving': 'Sauvegarde...',
  'forms.submitting': 'Soumission...',

  // Farm Form Placeholders
  'forms.placeholders.enterFarmName': 'Entrez le nom de votre ferme ou entreprise',
  'forms.placeholders.enterFarmAddress': 'Entrez l\'adresse complète de la ferme (rue, ville, code postal)',
  'forms.placeholders.enterAddress': 'Entrez l\'adresse complète de la ferme (rue, ville, code postal)',
  'forms.placeholders.selectLegalEntityType': 'Sélectionnez le type d\'entité légale',
  'forms.placeholders.enterTaxId': 'CNP (particuliers) ou numéro CUI/TVA (entreprises)',
  'forms.placeholders.enterSiret': 'CNP (particuliers) ou numéro CUI/TVA (entreprises)',
  'forms.placeholders.selectCountry': 'Sélectionnez le pays',
  'forms.placeholders.selectCountryFirst': 'Sélectionnez d\'abord le pays',
  'forms.placeholders.selectDepartment': 'Sélectionnez le département',
  'forms.placeholders.enterCity': 'Entrez la ville ou commune',
  'forms.placeholders.enterMobileNumber': 'Entrez le numéro de mobile avec l\'indicatif pays',
  'forms.placeholders.enterPhone': 'Entrez le numéro de mobile avec l\'indicatif pays',
  'forms.placeholders.selectLanguage': 'Sélectionnez la langue',
  'forms.placeholders.selectOwnershipType': 'Sélectionnez le type de propriété',
  'forms.placeholders.enterArea': 'Entrez la superficie',
  'forms.placeholders.specifyOtherActivities': 'Veuillez préciser les autres activités agricoles',
  'forms.placeholders.selectIrrigationMethod': 'Sélectionnez la méthode d\'irrigation',
  'forms.placeholders.enterNumberOfWorkers': 'Entrez le nombre de travailleurs',
  'forms.placeholders.enterWorkers': 'Entrez le nombre de travailleurs',
  'forms.placeholders.quantity': 'Quantité',
  'forms.placeholders.enterQuantity': 'Quantité',
  'forms.placeholders.specifyTypeAndQuantity': 'Précisez le type et la quantité',
  'forms.placeholders.specifyOtherSubsidy': 'Précisez toute autre subvention ou intérêt de soutien non listé ci-dessus',
  'forms.placeholders.specifyOtherInterests': 'Précisez toute autre subvention ou intérêt de soutien non listé ci-dessus',
  'forms.placeholders.selectRevenueRange': 'Sélectionnez la fourchette de revenus',

  // Subsidy Tracking Detail Sidebar
  'forms.placeholders.exampleAmount': 'ex: 50000',
  'forms.placeholders.exampleContactName': 'ex: Marie Dupont',
  'forms.placeholders.exampleEmail': 'email@exemple.fr',
  'forms.placeholders.examplePhone': '+33 1 23 45 67 89',
  'forms.placeholders.addNotesQuestionsReminders': 'Ajoutez vos notes, questions, ou rappels...',
  'forms.placeholders.exampleReferenceNumber': 'ex: SUBV-2025-1234',
  'forms.placeholders.exampleSubmissionMethod': 'ex: Portail en ligne, Email, Courrier',

  // Category Management Modal
  'forms.placeholders.exampleCategoryName': 'Ex: Clients VIP, En négociation...',

  // Prime/Energy Application Form Placeholders
  'forms.placeholders.exampleNumber': 'Ex: 250',
  'forms.placeholders.exampleSmallNumber': 'Ex: 4',
  'forms.placeholders.exampleMediumNumber': 'Ex: 100',
  'forms.placeholders.exampleLargeNumber': 'Ex: 15000',
  'forms.placeholders.exampleYear': 'Ex: 1990',
  'forms.placeholders.exampleIncome': 'Ex: 25000',
  'forms.placeholders.exampleDepartmentCodes': 'Ex: 75, 13, 69',
  'forms.placeholders.exampleArea80': 'Ex: 80',
  'forms.placeholders.exampleArea60': 'Ex: 60',
  'forms.placeholders.exampleArea50': 'Ex: 50',
  'forms.placeholders.exampleArea8': 'Ex: 8',
  'forms.placeholders.exampleArea300': 'Ex: 300',
  'forms.placeholders.exampleAge12': 'Ex: 12',
  'forms.placeholders.exampleAge10': 'Ex: 10',
  'forms.placeholders.exampleAge20': 'Ex: 20',
  'forms.placeholders.addNotesOrExplanations': 'Ajoutez vos notes ou explications supplémentaires...',

  // Simulation Form Placeholders
  'forms.placeholders.selectProjectType': 'Sélectionnez le type de projet',
  'forms.placeholders.enterTotalProjectCost': 'Entrez le coût total du projet',
  'forms.placeholders.enterProjectDuration': 'Entrez la durée du projet',
  'forms.placeholders.describeYourProject': 'Décrivez votre projet...',
  'forms.placeholders.zero': '0',

  // Company Edit Modals Placeholders
  'forms.placeholders.companyLegalName': 'Raison sociale de l\'entreprise',
  'forms.placeholders.selectLegalForm': 'Sélectionnez la forme juridique',
  'forms.placeholders.selectEmployeeRange': 'Sélectionnez la tranche d\'effectif',
  'forms.placeholders.sirenNumber': 'Numéro SIREN à 9 chiffres',
  'forms.placeholders.siretNumber': 'Numéro SIRET à 14 chiffres',
  'forms.placeholders.searchNafCode': 'Recherchez et sélectionnez votre code NAF...',
  'forms.placeholders.enterBusinessSectors': 'Entrez les secteurs d\'activité, séparés par des virgules',
  'forms.placeholders.firstName': 'Prénom(s)',
  'forms.placeholders.lastName': 'Nom',
  'forms.placeholders.selectPosition': 'Sélectionnez la fonction',
  'forms.placeholders.nationality': 'Nationalité',
  'forms.placeholders.city': 'Ville',
  'forms.placeholders.postalCode': 'Code postal',
  'forms.placeholders.fullAddress': 'Adresse complète',
  'forms.placeholders.siret14Digit': 'SIRET à 14 chiffres',
  'forms.placeholders.nafCode': 'Code NAF',
  'forms.placeholders.enterBusinessActivities': 'Entrez chaque activité commerciale sur une nouvelle ligne',
  'forms.placeholders.enterInnovationIndicators': 'Entrez les indicateurs d\'innovation sur des lignes séparées',
  'forms.placeholders.enterSustainabilityInitiatives': 'Entrez les initiatives de durabilité sur des lignes séparées',
  'forms.placeholders.enterExportMarkets': 'Entrez les marchés d\'export, séparés par des virgules',

  // Document Upload Placeholders
  'forms.placeholders.documentNameExample': 'ex., Certificat d\'enregistrement d\'entreprise',
  'forms.placeholders.selectDocumentType': 'Sélectionnez le type de document',
  'forms.placeholders.documentAdditionalInfo': 'Informations supplémentaires sur ce document...',

  // Security Audit Log Placeholders
  'forms.placeholders.filterByUserId': 'Filtrer par ID utilisateur',
  'forms.placeholders.eventType': 'Type d\'événement',
  'forms.placeholders.riskLevel': 'Niveau de risque',

  // New placeholder keys for modals and components
  'forms.placeholders.enterYourEmail': 'votre.email@exemple.com',
  'forms.placeholders.searchProfile': 'Rechercher un profil...',
  'forms.placeholders.searchClients': 'Rechercher des clients...',
  'forms.placeholders.colleagueEmail': 'collegue@entreprise.com',
  'forms.placeholders.chooseSubsidy': 'Choisir une subvention...',
  'forms.placeholders.addSubsidyNotes': 'Ajouter des notes sur cette subvention...',
  'forms.placeholders.enterCorrectValue': 'Entrez la valeur correcte si vous la connaissez',
  'forms.placeholders.describeWrong': 'Décrivez ce qui ne va pas ou fournissez un contexte supplémentaire...',
  'forms.placeholders.searchByNameOrNumber': 'Rechercher par nom ou numéro (ex: commerce, 47, restauration...)',
  'forms.placeholders.searchPotentialSubsidies': 'Rechercher des subventions potentielles...',
  'forms.placeholders.searchSubsidies': 'Rechercher des subventions...',
  'forms.placeholders.searchSectors': 'Rechercher des secteurs...',
  'forms.placeholders.typeProfileName': 'Tapez le nom du profil pour confirmer',
  'forms.placeholders.emailExample': 'nom@exemple.com',
  'forms.placeholders.addEmailsAbove': 'Ajoutez des emails ci-dessus pour inviter des membres',
} as const;
